import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Button, Col, Row, Tooltip, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

import { useCustomerDefaultFlags } from '@/redux/hooks/useCustomerSettings';
import FiledCard from '@/views/components/Cards/FiledCard';

import { routeFileSelector } from '../../../../../../utilz/i18n';
import FormCheckBox from '../../../../../components/Inputs/FormCheckBox';
import FormLabel from '../../../../../components/Labels/FormLabel';
import SecondaryLabel from '../../../../../components/Labels/SecondaryLabel';

const ProvidersListCard = ({
  providerDetails: { carrierName, tenderEmailAddress, lspStationCode },
  index,
  handleProviderClick,
  selected,
  isLastItem,
}) => {
  const tenderEmailAddressFormated = tenderEmailAddress?.replaceAll(';', ', ');
  const [expand, setExpand] = useState(false);
  const [render, setRender] = useState(0);
  const { selectedCompany } = useSelector((state) => state.auth);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const handleOpen = () => {
    setExpand(!expand);
    if (expand) {
      setRender(render + 1);
    }
  };

  const { flags } = useCustomerDefaultFlags(selectedCompany.companyId || 0, 'Shipment');

  const isShowLSPStationCode = flags.ShowLSPStationCode;

  return (
    <Row
      gutter={15}
      align="middle"
      className={`${!isLastItem && 'border-bottom-muted'} px-16 py-10`}
      key={render}
      wrap={false}
    >
      <Col xs={24} sm={14} md={12} lg={10} xl={10}>
        <FormCheckBox
          checkBoxClass="normal-checkbox align-items-center"
          className="m-0"
          onChange={(e) => handleProviderClick(e, index)}
          checked={selected}
          label={
            <>
              <FormLabel>{t('translation:default.fields.transportationProvider.label')}</FormLabel> <br />
              <SecondaryLabel className="fw-600 text-dark f-14">{carrierName}</SecondaryLabel>
            </>
          }
        />
      </Col>
      <Col xs={24} sm={10} md={8} lg={8} xl={8}>
        <FormLabel>{t('translation:default.fields.tenderEmailAddress')}</FormLabel>
        <br />
        <Typography.Paragraph
          className="m-0 fw-600 w-100 text-dark f-14"
          ellipsis={{
            expandable: true,
            onExpand: handleOpen,
            rows: 1,
          }}
        >
          {tenderEmailAddressFormated}
          {expand && (
            <Button type="link" className="ml-5 p-0 h-auto" onClick={handleOpen}>
              {t('translation:default.buttons.close')}
            </Button>
          )}
        </Typography.Paragraph>
      </Col>
      {isShowLSPStationCode && (
        <Col xs={24} sm={8} md={4} lg={6} xl={6}>
          <FiledCard
            textClass="mt-0"
            childClassName="label-one-line"
            title={t('translation:default.fields.lspStationCode.label')}
          >
            <FormLabel className="white-space-nowrap f-14 fw-600">
              {lspStationCode || (
                <Tooltip placement="bottom" title="No LSP Station Code mapped">
                  <WarningOutlined />
                </Tooltip>
              )}
            </FormLabel>
          </FiledCard>
        </Col>
      )}
    </Row>
  );
};

export default ProvidersListCard;
